// @ts-nocheck
import React, { useState } from "react";
import { m as motion } from "../../shared/components/Motion";
import "./about.css";
import Info from "./Info";
import AboutSkeleton from "./AboutSkeleton";
import { useAboutData } from "../../shared/hooks";
import { useAdmin } from "../../features/admin/AdminProvider";
import EditAboutModal from "../../features/admin/modals/EditAboutModal";
import {
  containerVariants,
  childVariantsMedium as childVariants,
  cld,
} from "../../shared/utils";

// Resolves either a Cloudinary public ID or a legacy full URL.
const resolveImg = (val, width) => {
  if (!val) return "";
  if (val.startsWith("http")) return val;
  return cld(val, width);
};

// Builds a Cloudinary URL that forces a browser download at original quality.
const resolveImgDownload = (val) => {
  if (!val) return "";
  if (val.startsWith("http")) return val;
  return `https://res.cloudinary.com/dc2dtlr4u/image/upload/fl_attachment/${val}`;
};

const About = () => {
  const [downloading, setDownloading] = useState(false);
  const [imageError, setImageError] = useState(false);
  const { data, loading } = useAboutData();
  const { adminMode, isAdmin, aboutDraft } = useAdmin();

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Use draft ONLY if admin is authenticated, otherwise use published data
  const displayData = isAdmin && aboutDraft ? aboutDraft : data || {};

  const handleDownload = () => {
    setDownloading(true);
    setTimeout(() => {
      setDownloading(false);
    }, 500);
  };

  const handleEditAbout = () => {
    setIsModalOpen(true);
  };

  // Show skeleton while loading
  if (loading || !displayData.description) {
    return <AboutSkeleton />;
  }

  return (
    <motion.section
      className="about section"
      id="about"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.h2 className="section__title" variants={childVariants}>
        About
      </motion.h2>
      <motion.span className="section__subtitle" variants={childVariants}>
        My introduction
      </motion.span>

      <motion.div
        className="about__container container grid"
        style={{ position: "relative" }}
        variants={containerVariants}
      >
        {imageError && (
          <div
            className="image-error__others img-err_custom"
            style={{ fontSize: "3rem" }}
          >
            <i className="uil uil-image-slash"></i>
          </div>
        )}
        <motion.img
          src={resolveImg(displayData?.imageId || displayData?.imageUrl, 700)}
          className="about__img"
          alt="Santhosh"
          title="Santhosh"
          width="350"
          height="350"
          loading="lazy"
          decoding="async"
          onError={() => setImageError(true)}
          style={{ display: imageError ? "none" : "block" }}
        />

        <motion.div className="about__data" variants={childVariants}>
          <Info data={displayData} />
          <motion.p className="about__description" variants={childVariants}>
            {displayData?.description || ""}
          </motion.p>
          <div
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <motion.a
              download="Santhosh_Resume.jpg"
              href={resolveImgDownload(
                displayData?.resumeId || displayData?.resumeUrl,
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="about__download-btn button button--flex"
              onClick={handleDownload}
              variants={childVariants}
            >
              {downloading ? "Downloading..." : "Download Resume"}
            </motion.a>

            {adminMode && (
              <motion.button
                onClick={handleEditAbout}
                whileHover={{ scale: 1.15 }}
                whileTap={{ scale: 0.9 }}
                style={{
                  marginLeft: "1rem",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "var(--body-color)",
                  background: "var(--title-color)",
                }}
                title="Edit about section"
              >
                <i className="bx bx-pencil"></i>
              </motion.button>
            )}
          </div>
        </motion.div>
      </motion.div>

      {/* Modal */}
      <EditAboutModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={() => setIsModalOpen(false)}
        aboutData={displayData}
        publishedData={data}
      />
    </motion.section>
  );
};

export default About;
